import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import "./src/operaciones.css"

import { Dashboard, MenuOutlined, Storage, TimelineOutlined, NotificationImportantOutlined, AccountTreeOutlined } from "@material-ui/icons";
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from "react-bootstrap/Container";
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link } from "react-router-dom";


export default function SubMenuOPReportes() {
    return (
        <div className="op-sub-menu-area">
            <Navbar collapseOnSelect expand className="menu-operaciones-new">

                <Container>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto menu-operaciones">

                            <Link to="/home/operaciones/:id/ReporteInscritosP">R. Inscritos</Link>
                            <Link to="/home/operaciones/:id/ReporteBanruralP">R. Pagos</Link>
                            <Link to="/home/operaciones/:id/ReporteS">R. Saldos</Link>
                            <Link to="/home/operaciones/:id/ReporteO">R. Operaciones</Link>

                        </Nav>
                    </Navbar.Collapse>

                </Container>
            </Navbar>
        </div>
    )
}

export function SubMenuOPOperaciones() {
    return (
        <div className="op-sub-menu-area">
            <Navbar collapseOnSelect expand className="menu-operaciones-new">

                <Container>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto menu-operaciones">

                            <Link to="/home/operaciones/:id/operacionM">M. Operaciones</Link>
                            <Link to="/home/operaciones/cargapagos/:id">Carga Pagos</Link>
                            <Link to="/home/operaciones/:id/Cuotass">Cuotas</Link>

                        </Nav>
                    </Navbar.Collapse>

                </Container>
            </Navbar>
        </div>
    )
}

export function SubMenuOExoneraciones() {
    return (
        <div className="op-sub-menu-area">
            <Navbar collapseOnSelect expand className="menu-operaciones-new">

                <Container>
                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />

                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto menu-operaciones">

                            <Link to="/home/operaciones/:id/Exoneracioness">S. Exoneración</Link>
                            <Link to="/home/operaciones/:id/AprobacionExoneraciones">A. Exoneración</Link>
                            

                        </Nav>
                    </Navbar.Collapse>

                </Container>
            </Navbar>
        </div>
    )
}